import { Toolbar } from '@octopus-do/octopus-storybook'
import { PaperclipLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useRef } from 'react'

import { useAttachFile } from '@/hooks'
import centerElement from '@/utils/centerElement'
import css from './styles.module.css'

interface Props {
  disabled: boolean
  // A picked file is uploading: the button shows a loader until it lands.
  loading: boolean
  // The plan has no attachments: the button looks off but sells the plan.
  locked: boolean
  onUpgrade: () => void
}

// The button opens the native file picker, so it owns its click instead of
// reporting a key to Toolbar.Root.
export const AttachFileButton: React.FC<Props> = ({
  disabled,
  loading,
  locked,
  onUpgrade,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { handleFile } = useAttachFile()
  const { closeMenus } = Toolbar.useToolbarContext()

  const onPick = () => {
    closeMenus()

    if (locked) {
      onUpgrade()
      return
    }

    inputRef.current?.click()
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    // Cleared so that picking the same file again fires a change event.
    event.target.value = ''

    if (file) {
      handleFile(file, centerElement(0, 0, []))
    }
  }

  return (
    <>
      <input
        className={css.input}
        onChange={onChange}
        ref={inputRef}
        type="file"
      />
      <Toolbar.DropdownButton
        active={false}
        disabled={disabled}
        icon={PaperclipLight}
        loading={loading}
        locked={locked}
        onClick={onPick}
        tooltip="Attach file"
      />
    </>
  )
}
